/* co-featured-articles — centre-focus sync. Wires to the co-flickity instance via its co-flickity:init
   event (must load BEFORE co-flickity.js so the listener is registered before that event fires). On each
   select it marks the selected cell .is-active (CSS lifts it above its neighbours via z-index; the
   size/overlap itself is the co-flickity coverflow stagger) and shows the matching info panel below
   (title / excerpt / button crossfade — the info box is a CSS grid stack, no JS sizing). Arrows are wired by
   co-flickity.js itself (they sit in the carousel's parent). Editor-resilient: re-fires on section:load. */
(function () {
  if (window.__coFeaturedArticles) return;
  window.__coFeaturedArticles = true;

  document.addEventListener('co-flickity:init', function (e) {
    var el = e.target;
    if (!el || !el.classList || !el.classList.contains('co-featured-articles-slider')) return;
    var flkty = e.detail && e.detail.flickity;
    if (!flkty) return;
    var root = el.closest('.co-featured-articles');
    if (!root) return;
    var panels = root.querySelectorAll('.co-featured-info-panel');

    function sync() {
      var idx = flkty.selectedIndex;
      var cells = flkty.cells || [];
      for (var i = 0; i < cells.length; i++) {
        cells[i].element.classList.toggle('is-active', i === idx);
      }
      for (var j = 0; j < panels.length; j++) {
        panels[j].classList.toggle('is-active', j === idx);
      }
    }

    flkty.on('select', sync);
    sync();
  });
})();
